import CookieProxy from './cookieProxy';
import clientCookies from './clientCookies';

let areCookiesEnabled = false;
if (clientCookies) {
  clientCookies.set('cookietest', 'testCookieVal');
  areCookiesEnabled = clientCookies.get('cookietest') === 'testCookieVal';
  clientCookies.remove('cookietest');
}
const cookiesEnabled = !!areCookiesEnabled;

export {
  CookieProxy,
  clientCookies,
  cookiesEnabled,
};
